<template>
</template>

<script>
	import {
		getItem,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'

	export default {
		data() {
			return {
				differtime: 0,
				setintime: null,
				setinlogin: null
			}
		},
		props: ['next'],
		methods: {
			countTime() {
				let res = getItem('userInfo')
				let that = this
				if (Number(res.endTime) > Number(res.startTime)) {
					that.$emit('signout', 0)
					const loginEnd = (Number(getItem('loginSuccess')) + ((Number(res.endTime) - Number(res.startTime)) * 1000))
					setItem('differtime', loginEnd)
					that.setintime = setInterval(() => {
						if (new Date().getTime() >= Number(getItem('differtime'))) {
							clearInterval(that.setintime)
							removeToken()
							removeItem('differtime')
							that.$router.push({
								name: 'login'
							})
						}
					}, 1000)
				}
				// if ((new Date().getTime()) < Number(res.startStamp)) {
				// 	that.setinlogin = setInterval(function(){
				// 		if (parseInt((Number(res.startStamp) - (new Date().getTime()))/1000) <= 0) {
				// 			that.$emit('signout', 0)
				// 			clearInterval(that.setinlogin)
				// 		} else {
				// 			that.$emit('signout', parseInt((Number(res.startStamp) - (new Date().getTime()))/1000))
				// 		}
				// 	}, 1000)
				// } else {
				// 	that.$emit('signout', 0)
				// 	if (Number(res.endTime) > Number(res.startTime)) {
				// 		if (getItem('differtime') === null || getItem('differtime') === 'null') {
				// 			that.differtime = Number(res.endTime) - Number(res.startTime)
				// 			setItem('differtime', Number(res.endTime) - Number(res.startTime))
				// 		} else {
				// 			that.differtime = getItem('differtime')
				// 		}
				// 		that.setintime = setInterval(function() {
				// 			setItem('differtime', getItem('differtime')-1)
				// 			if (Number(getItem('differtime')) <= 0) {
				// 				clearInterval(that.setintime)
				// 				removeToken()
				// 				removeItem('differtime')
				// 				that.$router.push({
				// 					name: 'login'
				// 				})
				// 			}
				// 		}, 1000)
				// 	}
				// }
			}
		},
		destroyed() {
			clearInterval(this.setinlogin)
			clearInterval(this.setintime)
		},
		watch: {
			next: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					this.countTime()
				}
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/UserTime.vue